import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {AnnoTypeEnum, EllipseAnnotation, Size} from '@mydocma/component-library/src/lib/annotation';
import {toARGB, toRGB} from './converter';

export class EllipseConverter {

  /* COMPONENT MODEL TO SCRIBBLE */
  static convertToData(anno: EllipseAnnotation, containerSize: Size): ScribbleData {
    const strokeWidth = anno.style?.stroke?.width ?? 3;
    const halfStroke = strokeWidth / 2;

    const adjustedMinX = anno.left - anno.radius.x - halfStroke;
    const adjustedMinY = anno.top - anno.radius.y - halfStroke;

    const width = 2 * anno.radius.x + strokeWidth;
    const height = 2 * anno.radius.y + strokeWidth;

    const stageWidth = containerSize.width;
    const stageHeight = containerSize.height;
    const relX = adjustedMinX / stageWidth;
    const relY = adjustedMinY / stageHeight;
    const relW = width / stageWidth;
    const relH = height / stageHeight;

    const ellipseData = `${anno.radius.x},${anno.radius.y}`;

    return {
      UniqueId: anno.id,
      RelativeBasePointToParentPositionX: relX,
      RelativeBasePointToParentPositionY: relY,
      RelativeScaleX: relW,
      RelativeScaleY: relH,

      RelativeAnchorToParentPositionX: 0,
      RelativeAnchorToParentPositionY: 0,
      RelativeAnchorToCanvasPositionX: 0,
      RelativeAnchorToCanvasPositionY: 0,

      ScribblePath: ellipseData,
      PinShape: anno.type,
      BorderColorValue: toARGB(anno.style?.stroke?.color ?? '#0000FFFF', anno.style?.stroke?.opacity),
      BorderWidth: strokeWidth,
      FillColorValue: anno.style.fillColor ?? '#FFFFFF00',
    } as ScribbleData;
  }

  /* SCRIBBLE TO COMPONENT MODEL */
  static convertToModel(scribble: ScribbleData, container: Size): EllipseAnnotation {
    const width = (scribble.RelativeScaleX || 0) * container.width;
    const height = (scribble.RelativeScaleX || 0) * container.height;
    const radiusX = width / 2;
    const radiusY = height / 2;

    const strokeWidth = scribble.BorderWidth ?? 3;

    const left = container.width * scribble.RelativeBasePointToParentPositionX - (scribble.RelativeAnchorToCanvasPositionX || 0) * width;
    const top = container.height * scribble.RelativeBasePointToParentPositionY - (scribble.RelativeAnchorToCanvasPositionY || 0) * height;

    return {
      text: scribble?.Text,
      type: scribble.PinShape,
      id: scribble.UniqueId,
      style: {
        text: {
          size: scribble.TextBoxFontSize,
          color: toRGB(scribble.TextBoxFontColorValue)
        },
        stroke: {
          color: toRGB(scribble.BorderColorValue),
          width: scribble.BorderWidth,
          opacity: scribble.PinShape === AnnoTypeEnum.Marker ? 0.7 : 1    // (scribble.strokeOpacity ?? 1)
        },
        fillColor: toRGB(scribble.FillColorValue)
      },
      left,
      top,
      radius: {x: radiusX, y: radiusY},
      width,
      height,
    };
  }
}
